import { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";

import DialogComponent from "../../../../common/components/functional/dialogs/DialogComponent";
import OverlaySpinner from "../../../../common/components/functional/overlaySpinner/OverlaySpinner";
import { ManualSalary } from "../../../talents/talentAPI";
import {
  AssignmentOption,
  CcOption,
  ExpenseTypeOption,
  Option,
} from "./ManualSalaries";
import { ManualSalaryForm } from "./ManualSalaryForm";

interface Props {
  isOpen: boolean;
  close: () => void;
  manualSalary: ManualSalary | null;
  assignmentOptions: AssignmentOption[];
  ccOptions: CcOption[];
  eezyCcOptions: Option[];
  expenseTypeOptions: ExpenseTypeOption[];
  typeOptions: Option[];
  employmentId: string;
  employmentStart: string;
  employmentEnd: string;
  employerName: string;
  updateManualSalaries: (manualSalary: ManualSalary) => void;
  isLoading: boolean;
}

export const ManualSalaryDialog = ({
  isOpen,
  close,
  manualSalary,
  assignmentOptions,
  ccOptions,
  eezyCcOptions,
  expenseTypeOptions,
  typeOptions,
  employmentId,
  employmentStart,
  employmentEnd,
  employerName,
  updateManualSalaries,
  isLoading,
}: Props) => {
  const defaultValues = useMemo(
    () => ({
      manualSalaryId: "",
      type: "",
      expenseTypeCode: manualSalary?.expenseTypeCode || "",
      description: manualSalary?.description || "",
      date: manualSalary?.date || "",
      amount: manualSalary?.amount || "",
      unitCost: manualSalary?.unitCost || "",
      assignmentId: manualSalary?.assignmentId || "",
      costCenterId: manualSalary?.customerCostCenterId || "",
      eezyCostCenterId: manualSalary?.eezyCostCenterId || "",
      isBillable: manualSalary?.isBillable || false,
    }),
    [manualSalary],
  );

  const methods = useForm({ defaultValues, mode: "onChange" });

  const { reset } = methods;

  useEffect(() => {
    reset(defaultValues);
  }, [manualSalary, reset, defaultValues]);

  return (
    <DialogComponent
      open={isOpen}
      onClose={() => {}}
      autoWidth
      sx={{
        borderRadius: "4px",
        minWidth: "600px",
        maxWidth: "600px",
      }}
    >
      <>
        <ManualSalaryForm
          close={close}
          manualSalary={manualSalary}
          assignmentOptions={assignmentOptions}
          ccOptions={ccOptions}
          expenseTypeOptions={expenseTypeOptions}
          eezyCcOptions={eezyCcOptions}
          typeOptions={typeOptions}
          employmentId={employmentId}
          employmentStart={employmentStart}
          employmentEnd={employmentEnd}
          employerName={employerName}
          updateManualSalaries={updateManualSalaries}
          isLoading={isLoading}
        />
        <OverlaySpinner isLoading={isLoading} />
      </>
    </DialogComponent>
  );
};
